<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M3 8v18h26V8Zm4.3 2h17.4L16 15.8Zm-2.3.9 10.4 7 .6.3.6-.4 10.4-7V24H5Z"
    />
  </svg>
</template>
